import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {

    return (
    <div className="ui inverted vertical footer segment">
        <div className="ui center aligned container">
        <div className="ui stackable inverted divided grid">
            <div className="sixteen wide column">
            <h4 className="ui inverted header">Card Gallery</h4>
            <p>Copyright © 2022 Rob Gordon. All rights reserved</p>
            </div>
        </div>
        <div className="ui inverted section divider"></div>
        <div className="ui horizontal inverted small divided link list">
            <Link to="/"  className="item">Home</Link>
            <Link to="/"  className="item">Contact Us</Link>
            <Link to="/"  className="item">Terms & Conditions</Link>
        </div>
        </div>
    </div>
    )
  }
  export default Footer